// Política avançada de senhas (KLOCKSEC) — espelha o backend password-policy.ts.
export const PASSWORD_CHECKS: { label: string; test: (v: string) => boolean }[] = [
  { label: 'No mínimo 8 caracteres', test: (v) => v.length >= 8 },
  { label: 'Uma letra maiúscula', test: (v) => /[A-Z]/.test(v) },
  { label: 'Uma letra minúscula', test: (v) => /[a-z]/.test(v) },
  { label: 'Um número', test: (v) => /[0-9]/.test(v) },
  { label: 'Um caractere especial', test: (v) => /[!@#$%^&*(),.?":{}|<>]/.test(v) },
];

export function isStrongPassword(value: string): boolean {
  return PASSWORD_CHECKS.every((c) => c.test(value));
}
